export default {
    mutations: {
        
    },
    actions: {
        completeRecharge({commit}, payload){
            let url = '/wallet/recharge';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data).then(response=>{
                    // 200 → credit was applied inline; balance returned in body.
                    // 202 → "PROCESSING": webhook is the source of truth; the parent
                    // component should poll /wallet for the updated balance.
                    if (response.status === 200 && response.data && typeof response.data.credits !== 'undefined'){
                        commit('UPDATE_USER_CREDITS', response.data.credits)
                        commit('UPDATE_USER_LOAN_CREDITS', response.data.loan_credits)
                    }
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        createPaypalIntent({commit}, payload){
            let url = '/wallet/recharge/paypal/intent';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data).then(response=>{
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        rechargeViaEbmGateway({commit}, payload){
            let url = '/wallet/recharge/ebmgateway';
               
            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data).then(response=>{
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        borrowBalance({commit}, payload){
            let url = '/wallet/borrow';
               
            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data).then(response=>{
                    commit('UPDATE_USER_CREDITS', response.data.credits)
                    commit('UPDATE_USER_LOAN_CREDITS', response.data.loan_credits)
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        validatePromocode({commit}, payload){
            let url = '/wallet/promocode/validate';
               
            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data).then(response=>{
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        }
    }
}